module.exports = __webpack_public_path__ + "img/moonlamp_poster.f10a9ecd.png";